import { createGlobalStyle } from 'styled-components';
import { cssVariables } from './tokens';

/**
 * Global styles scoped to .v2-root — fonts, CSS vars, base resets.
 * Does NOT affect v1 components outside .v2-root.
 *
 * Fonts are loaded globally via App.css @font-face declarations.
 * No external font import needed.
 */
export const V2GlobalStyles = createGlobalStyle`
  .v2-root {
    ${cssVariables}

    font-family: var(--font-sans);
    color: var(--ink);
    background: var(--paper);
    font-size: 14px;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;

    *, *::before, *::after {
      box-sizing: border-box;
    }

    a {
      color: inherit;
      text-decoration: none;
    }

    button {
      font-family: inherit;
    }
  }
`;
